import { createContext, MutableRefObject } from "react";

const FilterControlContext = createContext<{
  applyFinalizers: MutableRefObject<Set<() => void>>;
} | null>(null);

export default FilterControlContext;
